// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3PVKm","label":"Section_label__L-MkV","contentWrap":"Section_contentWrap__Sq09C","footer":"Section_footer__3GDgT","footerInner":"Section_footerInner__K9OMT"};